import { render, staticRenderFns } from "./img-placeholder.vue?vue&type=template&id=d4d7cae6&"
import script from "./img-placeholder.vue?vue&type=script&lang=js&"
export * from "./img-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d7cae6')) {
      api.createRecord('d4d7cae6', component.options)
    } else {
      api.reload('d4d7cae6', component.options)
    }
    module.hot.accept("./img-placeholder.vue?vue&type=template&id=d4d7cae6&", function () {
      api.rerender('d4d7cae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeleton-item/img-placeholder.vue"
export default component.exports